<script>
import GeneralProductStatementSelectModal from "@core/components/product/GeneralProductStatementSelectModal.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import Button from "@core/components/common/Button.vue";
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {Button, HamletTable, GeneralProductStatementSelectModal, BFormCheckbox},
    props: {
        statements: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            config: null,
            fetchCallback: null,
            columns: [
                {
                    key: 'productStatement',
                    label: this.$t('Component(Grid):column-title'),
                },
                {
                    key: 'coveredExcluded',
                    label: this.$t('Component(Grid):column-covered-excluded'),
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions'),
                }
            ]
        }
    },
    methods: {
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;

            cb(
                this.statements.length,
                this.statements.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
        },
        selectProductStatement() {
            this.$refs.modal.show();
        },
        onProductStatementSelect(statement) {
            this.$emit('newStatement', {
                statement: statement,
                coveredExcluded: false
            });
        },
        remove(statement) {
            this.$emit('removeStatement', statement);
        }
    },
    watch: {
        statements() {
            this.fetch(this.config, this.fetchCallback);
        }
    }
}
</script>

<template>
    <div>
        <GeneralProductStatementSelectModal
            ref="modal"
            @input="onProductStatementSelect"
        />
        <HamletTable
            :columns="columns"
            :fetch="fetch"
            @created="onTableCreated"
        >
            <template #header-label>
                Product statements
            </template>

            <template #header-controls>
                <Button @click="selectProductStatement">
                    {{ $t('Component(Button):select-product-statement') }}
                </Button>
            </template>

            <template #cell-productStatement="data">
                {{ data.item.statement.productStatement }}
            </template>

            <template #cell-coveredExcluded="data">
                <b-form-checkbox
                    v-model="data.item.coveredExcluded"
                />
            </template>

            <template #cell-actions="data">
                <Button
                    class="btn-sm"
                    @click="remove(data.item)"
                >
                    {{ $t('Component(Button):remove') }}
                </Button>
            </template>

        </HamletTable>
    </div>
</template>
